import { render } from "./ReleaseVideo.vue?vue&type=template&id=77c4f942&scoped=true&ts=true"
import script from "./ReleaseVideo.vue?vue&type=script&lang=ts"
export * from "./ReleaseVideo.vue?vue&type=script&lang=ts"

import "./ReleaseVideo.vue?vue&type=style&index=0&id=77c4f942&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c4f942"]])

export default __exports__